import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-card" }
const _hoisted_2 = { class: "modal-card-head" }
const _hoisted_3 = { class: "modal-card-title" }
const _hoisted_4 = { class: "modal-card-body" }
const _hoisted_5 = { class: "modal-card-foot" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Confirm & Save ")


const __default__ = {
  name: "SVModalComponent",
};
import { UseColumnModalHelper } from "../../Helper/Stateful/UseColumnModalHelper";
import { computed, toRefs, WritableComputedRef } from "vue";
import ColumnSelection from "./ColumnSelection.vue";


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modalActive: { type: Boolean },
    refName: null,
    width: null,
    title: null,
    columns: null,
    availableColumns: null,
    columnHeaders: null,
    showConfirm: { type: Boolean }
  },
  emits: ["update:modalActive", "closeClick", "confirmClick", "update:selectedColumns"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "update:modalActive", val: boolean): void;
  (e: "closeClick", val: boolean): void;
  (e: "confirmClick", val: boolean): void;
  (e: "update:selectedColumns", val: string[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modalActive: boolean;
  refName?: string;
  width?: string | number;
  title?: string;
  columns?: string[];
  availableColumns?: string[];
  columnHeaders?: Record<string, string>;
  showConfirm?: boolean;
}





const {
  modalActive,
  refName,
  width,
  columns,
  columnHeaders,
  availableColumns,
  showConfirm,
  title,
} = toRefs(props);

const componentModalActive = computed({
  get() {
    return modalActive.value;
  },
  set(val) {
    emits("update:modalActive", val);
  },
});
let componentColumns: WritableComputedRef<string[]>;
if (columns && columns.value) {
  const { columns: columnsComputed, setColumns } = UseColumnModalHelper(
    columns.value
  );
  componentColumns = computed({
    get(): string[] {
      return columnsComputed.value;
    },
    set(val: string[]) {
      setColumns(val);
    },
  });
}

return (_ctx: any,_cache: any) => {
  const _component_o_button = _resolveComponent("o-button")!
  const _component_o_modal = _resolveComponent("o-modal")!

  return (_openBlock(), _createBlock(_component_o_modal, {
    "trap-focus": "",
    "aria-role": "dialog",
    "aria-modal": "",
    active: _unref(componentModalActive),
    "onUpdate:active": _cache[3] || (_cache[3] = ($event: any) => (_isRef(componentModalActive) ? (componentModalActive).value = $event : null)),
    ref: _unref(refName),
    width: _unref(width)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "header", {}, () => [
          _createElementVNode("header", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(title)), 1)
          ])
        ]),
        _createElementVNode("section", _hoisted_4, [
          _renderSlot(_ctx.$slots, "body", {}, () => [
            _createVNode(ColumnSelection, {
              "available-columns": _unref(availableColumns),
              "selected-columns": _unref(componentColumns),
              "onUpdate:selected-columns": _cache[0] || (_cache[0] = ($event: any) => (_isRef(componentColumns) ? (componentColumns).value = $event : componentColumns = $event)),
              "column-headers": _unref(columnHeaders)
            }, null, 8, ["available-columns", "selected-columns", "column-headers"])
          ])
        ]),
        _createElementVNode("footer", _hoisted_5, [
          _renderSlot(_ctx.$slots, "footer", {}, () => [
            _createElementVNode("button", {
              class: "button",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (componentModalActive.value = false))
            }, " Close "),
            _renderSlot(_ctx.$slots, "confirm", {}, () => [
              (_unref(showConfirm))
                ? (_openBlock(), _createBlock(_component_o_button, {
                    key: 0,
                    variant: "primary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('confirmClick', true)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _: 3
  }, 8, ["active", "width"]))
}
}

})